module.exports = __webpack_public_path__ + "img/banner-privacy.1a70e90c.jpg";